<template>
  <div>
    <s-card :border="false" :padding="false" class="flex-grow pr-0">
      <div class="three-column-grid">
        <div class="flex justify-center pl-16">
          <s-avatar :fullname="displayName" />
        </div>
        <div class="flex flex-column">
          <span class="title-label">{{ displayName }}</span>
          <span class="value-label pt-8">{{ messageBody }}</span>
          <div class="file-boxes-grid pt-24" v-if="attachments">
            <s-file-box
              v-for="(attachment, msgFileIndex) of attachments"
              :key="msgFileIndex"
              :file-size="attachment.fileSize"
              :file-name="attachment.documentName"
              :icon="attachment.icon"
              :readonly="true"
              @on-file-click="
                () => {
                  downloadAttachment(attachment);
                }
              "
            />
          </div>
        </div>
        <div class="flex flex-column">
          <span class="title-label color-dim">{{ convertedMsgTime }}</span>
        </div>
      </div>
    </s-card>
  </div>
</template>

<script>
import SCard from "./SCard";
import SAvatar from "./SAvatar";
import SFileBox from "./SFileBox";
import moment, { defaultFormat, duration } from "moment";

export default {
  name: "Message",
  components: {
    SAvatar,
    SCard,
    SFileBox,
  },
  props: {
    username: {},
    displayName: {},
    messageBody: { required: true },
    messageTime: { required: true },
    attachments: {},
    fullname: {},
  },
  data: function () {
    return {
      inputFocused: false,
      convertedMsgTime: null,
    };
  },
  methods: {
    downloadAttachment(attachment) {
      this.$emit("open-attachment", attachment);
    },
    checkDate() {
      /* if the prop value is a valid dateTime format */
      if (moment(this.messageTime, "YYYY-MM-DD h:mm A").isValid()) {
        let today = moment().format("YYYY-MM-DD h:mm A");
        let msgTime = moment(this.messageTime).format("YYYY-MM-DD h:mm A");
        let difference = duration(moment(msgTime).diff(today)).humanize(true);
        this.convertedMsgTime = difference;
      } else {
        /* if the prop value is a valid Time fromat */
        if (moment(this.messageTime, "h:mm A").isValid()) {
          this.convertedMsgTime = this.messageTime;
        } else {
          /* If the prop value is not a proper dateTime or Time Format */
          this.convertedMsgTime = "Invalid DateTime Format";
        }
        /* Not using this anymore */
        // let splitTime = difference.split(" ");
        // if (parseInt(splitTime[0]) >= 24 && splitTime[1] == "hours") {
        //   this.convertedMsgTime = moment(msgTime).format("h:mm A");
        //   console.log(this.convertedMsgTime, "split")
        // } else if (splitTime[1] == "days" || splitTime[1] == "months") {
        //   this.convertedMsgTime = moment(msgTime).format("h:mm A");
        // } else {
        //   this.convertedMsgTime = difference;
        // }
      }
    },
  },
  mounted() {
    if (this.messageTime) {
      this.checkDate();
    }
  },
};
</script>

<style scoped lang="scss">
.flex-grow {
  flex-grow: 1;
  align-self: stretch;
}

.message-box {
  height: 57px !important;
  display: flex;
}

.container {
  height: 100%;
  width: 100%;
}

.flex {
  display: flex;
  flex: 1;
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}
.content-stretch {
  align-content: stretch;
}
.content-center {
  align-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.items-center {
  align-items: center;
}
.text-bold {
  font-weight: bold;
}

.width-100 {
  width: 100%;
}
.height-100 {
  height: 100%;
}
.font-14 {
  font-size: 16px;
}

.no-resize {
  resize: none;
}

.pb-16 {
  padding-bottom: 16px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pr-12 {
  padding-right: 12px;
}

.pt-8 {
  padding-top: 8px;
}

.p-8 {
  padding: 8px;
}
.pr-0 {
  padding-right: 0;
}

.p-12 {
  padding: 18px;
}
.pl-64 {
  padding-left: 64px;
}

.pl-64 {
  padding-left: 64px;
}

.three-column-grid {
  display: grid;
  grid-template-columns: 0.5fr 8fr 100px;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
}

.file-boxes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
}
</style>